import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../service/ApiService";
import { apiPaths } from "../../../service/apiPaths";
import {
  formatDateToISODateString,
  limit,
  updateComponent,
  ViewType,
} from "../../../util/constant";
import { ITaskSheet } from "../Backlog/Tasksheet.props";

const useTaskSheet = () => {
  const [selectedTaskSheetId, setSelectedTaskSheetId] = useState<string | null>(
    null
  );
  const [backLogData, setBackLogData] = useState<ITaskSheet[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [search, setSearch] = useState<string>("");
  const [backPage, setBackPage] = useState<number>(1);
  const [backLogPage, setBackLogPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [description, setDescription] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [adminComment, setAdminComment] = useState<string>("");

  const navigate = useNavigate();

  const handleBackLog = async (fromDate: Date | null, toDate: Date | null) => {
    console.log("handleBackLog");
    setLoading(true);
    try {
      let endpoint = `${apiPaths.getBackLogTaskSheet}?page=${backPage}&limit=${limit}`;
      if (fromDate && toDate) {
        const formattedFromDate = formatDateToISODateString(fromDate);
        const formattedToDate = formatDateToISODateString(toDate);
        endpoint = `${apiPaths.getBackLogTaskSheet}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&page=${backPage}&limit=${limit}`;
      }
      const result = await ApiService({
        method: "GET",
        endpoint: endpoint,
      });
      setBackLogData(result.data);
      setBackLogPage(result.totalPages);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id: string) => {
    setSelectedTaskSheetId(id);
  };

  const handleStatusUp = async (id: string) => {
    setDeletingId(id);
    setShowConfirmation(true);
  };
  const handleCancelStatusUp = () => {
    setShowConfirmation(false);
    setDeletingId(null);
  };

  const updateScreen = (type: ViewType) => {
    updateComponent(type, () => {}, setSelectedTaskSheetId);
  };

  const handleSelectStatus = (e: any, id: any) => {
    const status = e.target.value;
    if (status === "query" || status === "backLog") {
      setShowModal(true);
      setSelectedStatus(status);
      setSelectedId(id);
    } else {
      handleConfirmStatusUp(id, status, "");
    }
  };

  const handleModalSubmit = () => {
    handleConfirmStatusUp(selectedId, selectedStatus, description);
    setShowModal(false);
    setDescription("");
  };

  const handleModalClose = () => {
    setShowModal(false);
    setDescription("");
  };

  const handleConfirmStatusUp = async (
    id: any,
    status: any,
    description: string
  ) => {
    setLoading(true);
    const queryData = {
      status: status,
      query: description,
    };
    const backLogData = {
      status: status,
      backLog: description,
    };
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateTaskSheet}${id}`,
        data: status === "query" ? queryData : backLogData,
      });

      // Optionally refresh all tables
    
      handleBackLog(null, null);
      
    } catch (error) {
      console.error("Error updating task status:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    selectedTaskSheetId,
    showConfirmation,
    handleEdit,
    handleStatusUp,
    handleCancelStatusUp,
    handleConfirmStatusUp,
    handleBackLog,
    handleSelectStatus,
    updateScreen,
    loading,
    setSearch,
    search,
    setBackPage,
    backPage,
    backLogData,
    backLogPage,
    showModal,
    description,
    setDescription,
    handleModalSubmit,
    handleModalClose,
    adminComment,
  };
};

export default useTaskSheet;
